import { CopyOutlined } from '@ant-design/icons';
import { Button, message } from 'antd';

interface CopyableTextProps {
	text: string;
	children?: React.ReactNode;
	className?: string;
}

const CopyableText = ({ text, children, className }: CopyableTextProps) => {
	return (
		<div className="flex items-center gap-2">
			{children ? children : <span className={className ? className : ''}>{text}</span>}
			<Button
				size="small"
				icon={<CopyOutlined />}
				onClick={() => {
					navigator.clipboard.writeText(text);
					message.success('Copied to clipboard');
				}}
			/>
		</div>
	);
};

export default CopyableText;
